/*
| Cached DOM selectors
*/
const DOM = {
	container: $('.zipcode-checker-container'),
	loaderContainer: $('.zipcode-checker-loader-container'),
	totalStock: $('.total-stock'),
	totalStockContainer: $('.total-stock-container'),
	content: $('.zipcode-checker-content'),
	button: $('.zipcode-checker-button'),
	changeLocationBtn: $('.change-your-location-button'),
	input: $('.zipcode-checker-input'),
	error: $('.zipcode-checker-error-message'),
	stockLabel: $('.stock-quantity-zipcode-checker'),
	title: $('.zipcode-checker-title'),
	atcButtonDiv: $('#product div.cart'),
};

const isMetroShippingEligible =
	$('.zipcode-checker-container').attr('data-metro-shipping') == 'eligible';

const savedZipcodeLocation = JSON.parse(
	localStorage.getItem('customer-zipcode-location')
);

/* NEWLY ADDED
| Zip prefix to coast map provided by client.
| First digit of zip code determines the coast region.
*/
const ZIP_PREFIX_COAST_MAP = {
	0: 'East Coast',
	1: 'East Coast',
	2: 'East Coast',
	3: 'East Coast',
	4: 'East Coast',
	5: 'East Coast',
	6: 'West Coast',
	7: 'West Coast',
	8: 'West Coast',
	9: 'West Coast',
};

/* NEWLY ADDED
| UPDATED PER CLIENT REQUEST
| Exception ranges that override the single-digit default above:
| - Zips starting 57-59   -> West Coast (overrides default "5" = East Coast)
| - Zips starting 60-65   -> East Coast (overrides default "6" = West Coast)
| - Zips starting 700-729 -> East Coast (overrides default "7" = West Coast)
| Any other zip starting with 6 or 7 keeps the default (West Coast).
*/
const detectCoastFromZip = (zipcode) => {
	const zip = String(zipcode);

	const twoDigitPrefix = parseInt(zip.substring(0, 2), 10);
	const threeDigitPrefix = parseInt(zip.substring(0, 3), 10);

	// Most specific exception first: 700-729
	if (
		!isNaN(threeDigitPrefix) &&
		threeDigitPrefix >= 700 &&
		threeDigitPrefix <= 729
	) {
		return 'East Coast';
	}

	// 57-59 exception
	if (!isNaN(twoDigitPrefix) && twoDigitPrefix >= 57 && twoDigitPrefix <= 59) {
		return 'West Coast';
	}

	// 60-65 exception
	if (!isNaN(twoDigitPrefix) && twoDigitPrefix >= 60 && twoDigitPrefix <= 65) {
		return 'East Coast';
	}

	// Fallback to single-digit default
	const onePrefix = zip.charAt(0);
	return ZIP_PREFIX_COAST_MAP[onePrefix] ?? 'Unknown';
};

/*
| Map coast labels with warehouse names
| Used for matching warehouse inventory location.
*/
const coastWarehouseMap = {
	'East Coast': 'East Coast Warehouse',
	'West Coast': 'West Coast Warehouse',
};

/*
| Generate standard error response object
*/
const errorResponse = (message, extra = {}) => ({
	error: message,
	...extra,
});

/*
| Debounce helper function
*/
function debounce(fn, delay) {
	let timer;

	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => fn.apply(this, args), delay);
	};
}

/* NEWLY ADDED
| Replaced fetchZipcodeData. Validates zipcode and detects coast locally.
| No external API call needed anymore.
*/
function fetchZipcodeData(zipcode) {
	if (!zipcode || zipcode.length < 5 || zipcode.length > 5) {
		return errorResponse('No zipcode provided.', { type: 'zipcode' });
	}

	const coast = detectCoastFromZip(zipcode);

	return { coast };
}

/*
| Normalize inventory API response
| Extract warehouse location and inventory quantity.
*/
function getLocationsAndInventory(apiResponse) {
	const levels = apiResponse?.inventoryLevels ?? [];

	return levels.map(({ node }) => {
		const locationName = node?.location?.name;
		const quantity = node?.quantities?.[0]?.quantity ?? 0;

		return {
			location: locationName,
			quantity,
		};
	});
}

/*
| Check warehouse inventory for selected coast
| Returns available rapid shipping inventory count.
*/
function checkRapidShippingAvailability(rows, coast) {
	const userCoastLabel = coastWarehouseMap[coast];

	if (!userCoastLabel) {
		return 0;
	}

	const matchingWarehouse = rows.find(({ location }) =>
		location?.includes(userCoastLabel)
	);

	if (matchingWarehouse && matchingWarehouse.quantity > 0) {
		return matchingWarehouse.quantity;
	}

	return 0;
}

/*
| Update stock message in UI
*/
function updateShippingInfo(message) {
	DOM.totalStock.text(message);
	if (message.includes('not available')) {
		DOM.totalStock.addClass('not-available');
	} else {
		DOM.totalStock.removeClass('not-available');
	}
}

/*
| Show change location button
| Hide zipcode input section after successful lookup.
*/
function enableBowAndZipcodeChecker() {
	DOM.title.addClass('d-none');
}

/*
| Hide change location button
| Show zipcode input section again for user update.
*/
function disableBowAndZipcodeChecker() {
	DOM.title.removeClass('d-none');
}

/*
| Show loading state during API request
| Hides stock message while inventory loads.
*/
function enableLoader() {
	DOM.loaderContainer.removeClass('d-none');
	DOM.totalStock.addClass('d-none');
}

/*
| Hide loading state after API completion
| Restores stock message visibility in UI.
*/
function disableLoader() {
	DOM.loaderContainer.addClass('d-none');
	if (!!localStorage.getItem('customer-zipcode-location')) {
		DOM.totalStock.removeClass('d-none');
	}
}

/*
| Update ATC button based on available count
*/
function updateATCButton(availableCount) {
	const atcButton = DOM.atcButtonDiv.find('.button-cart.not-empty.add-to-cart');
	const quantityWrapper = DOM.atcButtonDiv.find('.quantity-wrapper');

	const inStock = !!availableCount;

	atcButton
		.css({
			'pointer-events': inStock ? 'auto' : 'none',
			width: inStock ? '' : '90%',
		})
		.val(inStock ? 'Add to Cart' : 'Out of Stock');

	quantityWrapper.toggleClass('d-none', !inStock);
}

/*
| Fetch warehouse inventory by variant and coast
| Updates rapid shipping availability message in UI.
*/
function fetchRapidShippingInventory(currentVariant, coast) {
	if (currentVariant == null) {
		console.error('== Variant ID is undefined or null ===');
		return;
	}

	enableLoader();

	if (!isMetroShippingEligible) {
		enableBowAndZipcodeChecker();
		setTimeout(() => {
			updateShippingInfo(
				`In stock for immediate shipping from our ${coast} warehouse.`
			);
			disableLoader();
		}, 1000);
		return;
	}

	$.ajax({
		url: `${window.location.origin}/apps/inventory-by-location?variant_id=${currentVariant}`,
		method: 'GET',
		dataType: 'json',

		success: function (data) {
			const rows = getLocationsAndInventory(data);


			const availableCount = checkRapidShippingAvailability(rows, coast);

			const message = availableCount
				? `In stock for immediate shipping from our ${coast} warehouse.`
				: 'This item is not available for delivery to your zip code.';

			updateShippingInfo(message);

			updateATCButton(availableCount);

			enableBowAndZipcodeChecker();
			disableLoader();
		},

		error: function (xhr, status, err) {
			console.error('== error ===', err);
			disableLoader();
		},
	});
}

/*
| Update product status based on zipcode checker container visibility
*/
function updateProductStatus() {
	DOM.loaderContainer.addClass('d-none');
}

/*
| Handle zipcode check button click
| Validates zipcode and fetches rapid shipping inventory.
*/
DOM.button.on('click', async function (e) {
	const zipcode = DOM.input.val().trim();

	/* NEWLY ADDED - fetchZipcodeData is now synchronous, no await needed. */
	const result = fetchZipcodeData(zipcode);

	const { error, coast } = result;

	if (error) {
		DOM.error.removeClass('d-none');
		DOM.totalStock.addClass('d-none');
		console.error('== error ==', error);
		return;
	}

	if (coast === 'Unknown') {
		DOM.error.text("Sorry, we don't ship to your region yet.");
		DOM.error.removeClass('d-none');
		DOM.totalStock.addClass('d-none');

		return;
	}

	DOM.error.addClass('d-none');

	localStorage.setItem(
		'customer-zipcode-location',
		JSON.stringify({
			zipcode,
			coast: coast,
		})
	);

	const currentVariant = $(e.target)
		.closest('.zipcode-checker-container')
		.attr('data-selected-variant-id');

	fetchRapidShippingInventory(currentVariant, coast);
});


/*
| Get variant ID from selected option text
| Matches variant dropdown option with swatch label.
*/
function getVariantID(optionText) {
	const variantSelect = $('#product-variants select');

	const variantID = variantSelect
		.find('option')
		.filter(function () {
			return $(this).text().trim().includes(optionText);
		})
		.val();

	return variantID;
}

/*
| Handle product swatch selection click
| Updates variant inventory and shipping availability.
*/
$(document).on('click', '.swatch-element label', function () {
	const option = $(this).text();
	const stockAmount = $(
		`.prod-icon input[type="hidden"][title*="${option.trim()}"]`
	).attr('quantity');
	const availability = $(this).siblings('input').data('availability');
	const variantID = getVariantID(option.trim());
	const getZipcodeLocation = JSON.parse(
		localStorage.getItem('customer-zipcode-location')
	);
	const zipcodeCheckerContainer = DOM.container;
	const stockLabel = DOM.stockLabel;

	DOM.error.addClass('d-none');
	DOM.input.val(getZipcodeLocation?.zipcode ?? '');

	zipcodeCheckerContainer.toggleClass('d-none', !availability);

	zipcodeCheckerContainer.attr('data-selected-variant-id', variantID);

	if (!availability) {
		return;
	}

	if (getZipcodeLocation) {

		const coast = getZipcodeLocation.coast;

		fetchRapidShippingInventory(variantID, coast);
	} 
});

/*
| Handle input change in zipcode input field
| Clears zipcode location if input is empty.
*/
DOM.input.on('input', function () {
	const zipcode = DOM.input.val().trim();
	if (zipcode.length == 0) {
		DOM.totalStock.addClass('d-none');
		DOM.title.removeClass('d-none');
		localStorage.removeItem('customer-zipcode-location');
	}
});

/*
| Handle enter key press in zipcode input field
| Triggers zipcode check button click.
*/
DOM.input.on('keydown', function (e) {
	if (e.key === 'Enter') {
		DOM.button.trigger('click');
	}
});

/*
| Restore saved customer shipping region
| Auto-fetch inventory if zipcode location already exists.
*/

if (savedZipcodeLocation) {

	DOM.input.val(savedZipcodeLocation.zipcode);

	const coast = savedZipcodeLocation.coast;

	if (!isMetroShippingEligible) {
		$('.total-stock').removeClass('d-none');
		enableBowAndZipcodeChecker();
		updateProductStatus();
		updateShippingInfo(
			`In stock for immediate shipping from our ${coast} warehouse.`
		);
	}

	const currentVariant = DOM.container.attr('data-selected-variant-id');

	fetchRapidShippingInventory(currentVariant, coast);
} else {
	if (!isMetroShippingEligible) {
		updateProductStatus();
	}
	disableLoader();
}
